import api from '../services/api';
import swal from 'sweetalert2';
import AdminApi from "../services/api";
import Loc from "../services/localization";
import VueQrcode from 'vue-qrcode-component';

/* init */
const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'item'],

    data() {
        return {
            locale: LocService,
            title: '',
            qrData: '',
        };
    },
    watch: {
        show: function(val, oldVal) {
            if(val){
                this.title = this.item.name
                this.qrData = this.item.parentOrderUuid != null ? this.item.parentOrderUuid : this.item.orderUuid;
            }

        },
    },
    components: { VueQrcode },
    methods: {
        close() {
            this.$topnavbar.$emit('closeShowQrCode')
            this.imageUrl = '';
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        },

        downloadQrCode() {
            const qrCanvas = this.$refs.qrcodeRef.$el.querySelector('canvas');
            if (qrCanvas) {
                const dataUrl = qrCanvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = this.title + '-qr-code.png';
                link.click();
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/modals/ShowQrCodeDialog.js